import * as types from './types';
import API from '../../utils/api';
import { persistor } from '../';
import { setError } from './errors';
import { ENDPOINT_URL, internalError } from '../../constants/defaultValues';
import { getTranslation } from '../../utils/translation';
import DeviceService from '../../services/DeviceService';
import LocalStorage from '../../utils/localStorage';

// LOGIN USER
export const loginUser = ({ username, password }) => async dispatch => {
    dispatch({
        type: types.LOGIN_USER_REQUEST,
    });

    const macAddress = await getMacAddress();
    await API.post(`${ENDPOINT_URL}/security/auth`, { username, password, macAddress })
        .then(res => {
            const { token } = res.data;

            if (token && token !== '') {
                localStorage.removeItem('screenLock');
                setTokenToLs(token);
                dispatch({
                    type: types.LOGIN_USER_SUCCESS,
                    payload: true,
                });
            }
        })
        .catch(err => {
            const errors = err?.response?.data?.info?.errors;
            if (!errors) {
                dispatch({
                    type: types.LOGIN_USER_FAILED,
                    payload: internalError,
                });
                return false;
            }
            dispatch({
                type: types.LOGIN_USER_FAILED,
                payload: errors[0],
            });
            return false;
        });
};

// Unlock device
export const unlockDevice = userData => async dispatch => {
    try {
        dispatch({
            type: types.LOGIN_USER_REQUEST,
        });

        const macAddress = await getMacAddress();

        const response = await API.post(`${ENDPOINT_URL}/security/auth/unlock`, {
            ...userData,
            macAddress,
        });

        const { token } = response.data;

        if (token && token !== '') {
            localStorage.removeItem('screenLock');
            dispatch({
                type: types.LOGIN_USER_SUCCESS,
                payload: true,
            });
        }
    } catch (error) {
        console.error(error);

        const errors = error?.response?.data?.info?.errors;

        if (!errors) {
            dispatch({
                type: types.LOGIN_USER_FAILED,
                payload: internalError,
            });
            return false;
        }

        dispatch({
            type: types.LOGIN_USER_FAILED,
            payload: errors[0],
        });

        return false;
    }
};

// CHANGE PASSWORD
export const changePassword = ({ oldPassword, newPassword }) => async dispatch => {
    dispatch({
        type: types.CHANGE_PASSWORD_REQUEST,
    });
    await API.post(`${ENDPOINT_URL}/security/auth/change`, { oldPassword, newPassword })
        .then(res => {
            const { info } = res.data;
            if (info.success) {
                dispatch({
                    type: types.CHANGE_PASSWORD_SUCCESS,
                    payload: getTranslation('changePasswordSuccessMessage'),
                });
            }
        })
        .catch(err => {
            const { errors } = err.response.data.info;
            dispatch({
                type: types.CHANGE_PASSWORD_FAILED,
                payload: errors[0],
            });
            return false;
        });
};

// LOGOUT USER
export const logoutUser = () => async dispatch => {
    dispatch({
        type: types.LOGOUT_USER_REQUEST,
    });
    await API.post(`${ENDPOINT_URL}/security/auth/logout`)
        .then(res => {
            const { success } = res.data.info;
            if (success) {
                persistor.purge();
                sessionStorage.clear();
                LocalStorage.clear();
                dispatch({
                    type: types.LOGOUT_USER_SUCCESS,
                    payload: success,
                });
            }
        })
        .catch(err => {
            console.log({ data: err.response.data });
            // const { errors } = err.response.data.info;
            // dispatch(setError(errors[0]));
        });
};

//LOCK SCREEN
export const lockScreen = () => dispatch => {
    localStorage.setItem('screenLock', JSON.stringify(true));
    dispatch({
        type: types.LOCK_SCREEN,
    });
};

export const clearChangePassword = () => ({
    type: types.CLEAR_CHANGE_PASSWORD,
});

// If exists any token save it to local storage
const setTokenToLs = token => {
    sessionStorage.setItem('token', token);
    return sessionStorage.getItem(token) !== '';
};

const getMacAddress = async () => {
    const response = await DeviceService.getDeviceMacAddress();

    const macAddress = response?.data?.macAddress || '';

    sessionStorage.setItem('macAddress', macAddress);

    return macAddress;
};
